import { all, call, put, takeLatest } from "redux-saga/effects";
import { deleteCustomerAttachmentsErrorAction, deleteCustomerAttachmentsSuccessAction, getCustomerAttachmentsByIdErrorAction, getCustomerAttachmentsByIdRequestAction, getCustomerAttachmentsByIdSuccessAction, getCustomerAttachmentsErrorAction, getCustomerAttachmentsSuccessAction, saveCustomerAttachmentsErrorAction, saveCustomerAttachmentsSuccessAction } from "../../actions/customerAttachmentsAction";
import { Types } from "../../types";
import { Response, FileCustomerAttachment, GetResponseCustomerAttachment, SaveCustomerAttachment, SaveResponseCustomerAttachment } from "../../types/customerAttachments/apiRequestType";
import { deleteCustomerAttachmentsRequest, getCustomerAttachmentByIdRequest, getCustomerAttachmentsRequest, saveCustomerAttachmentsRequest } from "../apiRequests/customerAttachmentRequest";



function* saveHandler(action: any) {
    try {
        const response: { data: SaveResponseCustomerAttachment } = yield call(saveCustomerAttachmentsRequest, action.payload.params)

        yield put(
            saveCustomerAttachmentsSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            saveCustomerAttachmentsErrorAction({
                error: error.message
            })
        )
    }
}
function* getCustomerAttachmentsHandler(action: any) {
    try {
        const response: { data: GetResponseCustomerAttachment } = yield call(getCustomerAttachmentsRequest, action)
        yield put(
            getCustomerAttachmentsSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getCustomerAttachmentsErrorAction({
                error: error.message
            })
        )
    }
}

function* deleteCustomerAttachmentsHandler(action: any) {
    try {
        const response: { data: Response } = yield call(deleteCustomerAttachmentsRequest, action.payload.params)
        yield put(
            deleteCustomerAttachmentsSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            deleteCustomerAttachmentsErrorAction({
                error: error.message
            })
        )
    }
}

function* getCustomerAttachmentsByIdHandler(action: any) {
    try {
        const response: { data: FileCustomerAttachment } = yield call(getCustomerAttachmentByIdRequest, action.payload.id)
        yield put(
            getCustomerAttachmentsByIdSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getCustomerAttachmentsByIdErrorAction({
                error: error.message
            })
        )
    }
}





function* customerAttachmentsSaga() {
    yield all([takeLatest(Types.SAVE_ATTACHMENT_REQUEST, saveHandler)]);
    yield all([takeLatest(Types.GET_ATTACHMENT_REQUEST, getCustomerAttachmentsHandler)]);
    yield all([takeLatest(Types.DELETE_ATTACHMENT_REQUEST, deleteCustomerAttachmentsHandler)]);
    yield all([takeLatest(Types.GET_ATTACHMENT_BY_ID_REQUEST, getCustomerAttachmentsByIdHandler)]);
}

export default customerAttachmentsSaga